import { render, staticRenderFns } from "./HairColorsRegistryNewForm.vue?vue&type=template&id=162bc33e"
import script from "./HairColorsRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./HairColorsRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports